module.exports = __webpack_public_path__ + "img/131.1609666f.jpg";